import { object } from './type-checkers';

const mapper = object.type('mapper');

export default mapper;
